module.exports = __webpack_public_path__ + "media/images/skull1-ff9174e413e4140d32d297f2935addbb.png";